import { render, staticRenderFns } from "./ComponentWrapperBase.vue?vue&type=template&id=d9c1986a"
import script from "./ComponentWrapperBase.vue?vue&type=script&lang=js"
export * from "./ComponentWrapperBase.vue?vue&type=script&lang=js"
import style0 from "./ComponentWrapperBase.vue?vue&type=style&index=0&id=d9c1986a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports